export default __webpack_public_path__ + "static/stamina-vessels-6b87b2df24949f114759272ecd9f8852.png";